export default "__VITE_ASSET__5e483fb7__"